var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { TravelBuddySettingsModalData } from './travel.buddy.settings.modal.provider';
import { ScriptService } from '../../../../services/script.service';
import { ConfirmModalActions, ConfirmModalData } from "../../../../common/components/confirm.modal/confirm.modal.provider";
import { ConfirmModalComponent } from "../../../../common/components/confirm.modal/confirm.modal.component";
var TravelBuddySettingsModalComponent = /** @class */ (function (_super) {
    __extends(TravelBuddySettingsModalComponent, _super);
    function TravelBuddySettingsModalComponent(fb, accountApiService, alertify, formBuilder, modalService, renderer, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.renderer = renderer;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.loadingReport = false;
        _this.loadingTripPlannerSettings = false;
        _this.selectedTabIndex = 0;
        _this.tripPlannerSettings = {
            openAIKey: '',
        };
        _this.newCity = null;
        _this.settings = {
            isActive: false,
            version: 'old',
            showOnAllClientWidgets: false,
            nearbyCities: [],
            openAIAssistant: {
                id: '',
                vectorStoreId: '',
                files: [],
            },
            cityName: '',
            openAIKey: '',
            clientPrompt: '',
            isStandalone: false,
        };
        _this.isNewVersion = false;
        _this.account = Object.assign({}, data);
        return _this;
    }
    TravelBuddySettingsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            assistantId: [null, [Validators.required]],
            cityName: [null, [Validators.required]],
            apikey: [null, [Validators.required]],
        });
        this.tripPlannerForm = this.formBuilder.group({
            openAIKey: [null, [Validators.required]],
        });
        this.loading = true;
        this.accountApiService
            .getTravelBuddySettings(this.account.account.userName)
            .finally(function () { return (_this.loading = false); })
            .subscribe(function (settings) {
            if (settings) {
                _this.settings = settings;
                _this.isNewVersion = _this.settings.version === 'new';
            }
        });
    };
    TravelBuddySettingsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    TravelBuddySettingsModalComponent.prototype.toggleTravelBuddy = function () {
        var _this = this;
        this.accountApiService
            .setTravelBuddySettings(this.account.account.userName, this.settings)
            .finally(function () { return (_this.loading = false); })
            .subscribe(function (version) {
            _this.alertify.successfully('Set travel buddy settings');
        });
    };
    TravelBuddySettingsModalComponent.prototype.toggleVersion = function () {
        this.settings.version = this.settings.version === 'old' ? 'new' : 'old';
        this.isNewVersion = this.settings.version === 'new';
        this.toggleTravelBuddy();
    };
    TravelBuddySettingsModalComponent.prototype.addNearbyCity = function () {
        var _this = this;
        console.log(this.newCity);
        if (this.newCity) {
            if (this.settings.nearbyCities.some(function (x) { return x.placeId === _this.newCity.placeId; })) {
                this.alertify.warning('City already added');
                return;
            }
            this.settings.nearbyCities.push(this.newCity);
            this.newCity = null;
        }
    };
    TravelBuddySettingsModalComponent.prototype.removeNearbyCity = function (city) {
        this.settings.nearbyCities = this.settings.nearbyCities.filter(function (x) { return x.placeId !== city.placeId; });
    };
    TravelBuddySettingsModalComponent.prototype.saveNewSettings = function (event) {
        var _this = this;
        this.accountApiService
            .setTravelBuddySettings(this.account.account.userName, this.settings)
            .finally(function () {
            _this.loading = false;
            event.complete();
        })
            .subscribe(function (version) {
            _this.alertify.successfully('Set travel buddy settings');
        });
    };
    TravelBuddySettingsModalComponent.prototype.createAssistant = function (event) {
        var _this = this;
        this.accountApiService
            .createOpenAIAssistant(this.account.account.userName, this.settings.cityName, this.settings.openAIKey)
            .finally(event.complete)
            .subscribe(function (data) {
            if (data.success) {
                _this.settings.openAIAssistant.id = data.assistant.id;
                _this.alertify.successfully('Created assistant');
            }
            else {
                _this.alertify.error(data.error.message);
            }
        });
    };
    TravelBuddySettingsModalComponent.prototype.uploadFiles = function (event) {
        var _this = this;
        this.accountApiService
            .uploadTravelBuddyFiles(this.account.account.userName)
            .finally(event.complete)
            .subscribe(function (data) {
            console.log(data);
            _this.alertify.successfully('Uploaded files');
            _this.settings.openAIAssistant.files = data;
        });
    };
    TravelBuddySettingsModalComponent.prototype.deleteAssistant = function () {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.accountApiService
                    .deleteAssistant(_this.account.account.userName)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.alertify.success("Delete assistant successfully. Please also delete the OpenAI key and archive the project on OpenAI website.", 15);
                    _this.close();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete OpenAI Assistant for this client, this operation cannot be reverted?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    TravelBuddySettingsModalComponent.prototype.confirm = function (event) {
        var _this = this;
        this.accountApiService
            .setTravelBuddySettings(this.account.account.userName, this.settings)
            .finally(function () { return (_this.loading = false); })
            .subscribe(function (version) {
            _this.alertify.successfully('Set travel buddy settings');
            _this.close();
        });
    };
    TravelBuddySettingsModalComponent.prototype.getEventFileUploadTime = function () {
        if (this.settings && this.settings.openAIAssistant && this.settings.openAIAssistant.files) {
            var eventFile = this.settings.openAIAssistant.files.find(function (x) { return x.fileType === 'ImGoing-events'; });
            if (eventFile && eventFile.uploadedAt) {
                return new Date(eventFile.uploadedAt).toLocaleString();
            }
        }
        return 'N/A';
    };
    TravelBuddySettingsModalComponent.prototype.getPlaceFileUploadTime = function () {
        if (this.settings && this.settings.openAIAssistant && this.settings.openAIAssistant.files) {
            var placeFile = this.settings.openAIAssistant.files.find(function (x) { return x.fileType === 'ImGoing-places'; });
            if (placeFile && placeFile.uploadedAt) {
                return new Date(placeFile.uploadedAt).toLocaleString();
            }
        }
        return 'N/A';
    };
    TravelBuddySettingsModalComponent.prototype.changeTab = function ($event) {
        var _this = this;
        this.selectedTabIndex = $event;
        if (this.selectedTabIndex === 1) {
            this.loadingReport = true;
            this.accountApiService
                .getTravelBuddyReport(this.account.account.userName)
                .finally(function () { return (_this.loadingReport = false); })
                .subscribe(function (data) {
                console.log(data);
                _this.reports = data;
                console.log('this.chart', _this.chart);
                _this.chart && _this.chart.destroy();
                var chartUrl = "https://cdn.jsdelivr.net/npm/apexcharts";
                if (!ScriptService.isScriptExist(chartUrl)) {
                    var scriptElement = ScriptService.loadJsScript(_this.renderer, chartUrl);
                    scriptElement.onload = function () {
                        _this.loadChart(data);
                    };
                }
                else {
                    _this.loadChart(data);
                }
            });
        }
        if (this.selectedTabIndex === 2) {
            this.loadingTripPlannerSettings = true;
            this.accountApiService
                .getTripPlannerSettings(this.account.account.userName)
                .finally(function () { return (_this.loadingTripPlannerSettings = false); })
                .subscribe(function (data) {
                _this.tripPlannerSettings = data;
            });
        }
    };
    TravelBuddySettingsModalComponent.prototype.saveTripPlannerSettings = function (event) {
        var _this = this;
        this.accountApiService
            .setTripPlannerSettings(this.account.account.userName, this.tripPlannerSettings)
            .finally(event.complete)
            .subscribe(function (data) {
            _this.alertify.successfully('Saved trip planner settings');
        });
    };
    TravelBuddySettingsModalComponent.prototype.getKeys = function (obj) {
        return Object.keys(obj);
    };
    TravelBuddySettingsModalComponent.prototype.calculateAverageTimeByMonth = function (entries) {
        var _this = this;
        var total = 0;
        this.getKeys(entries).forEach(function (key) {
            total += _this.calculateAverageTime(entries[key]);
        });
        return parseFloat((total / this.getKeys(entries).filter(function (x) { return !!entries[x]; }).length).toFixed(1));
    };
    TravelBuddySettingsModalComponent.prototype.calculateAverageTime = function (entries) {
        if (!entries) {
            return 0;
        }
        var total = entries.reduce(function (sum, entry) { return sum + entry.timeConsumed; }, 0);
        return parseFloat((total / entries.length).toFixed(1));
    };
    TravelBuddySettingsModalComponent.prototype.loadChart = function (reportData) {
        var _this = this;
        var total = [];
        this.getKeys(reportData)
            .reverse()
            .map(function (key) {
            reportData[key].total = reportData[key].length;
            total.push(_this.getKeys(reportData[key]).length);
        });
        var options = {
            series: [
                {
                    name: 'Activitied users',
                    group: 'Facebook',
                    data: total,
                },
            ],
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
            },
            stroke: {
                width: 1,
                colors: ['#fff'],
            },
            dataLabels: {
                formatter: function (val) {
                    // return val / 1000 + 'K';
                    return val;
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                },
            },
            xaxis: {
                categories: this.getKeys(reportData).reverse(),
            },
            fill: {
                opacity: 1,
            },
            colors: ['#4267B2'],
            yaxis: {
                labels: {
                    formatter: function (val) {
                        // return val / 1000 + 'K';
                        return val;
                    },
                },
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
            },
        };
        this.chart = new window['ApexCharts'](document.querySelector('#travel-buddy-report-chart'), options);
        this.chart && this.chart.render();
    };
    return TravelBuddySettingsModalComponent;
}(BaseComponent));
export { TravelBuddySettingsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.settings/travel.buddy.settings.modal.component.ts.pre-build-optimizer.js